import { NgModule } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { DatePicker } from 'primeng/datepicker';
import { Skeleton } from 'primeng/skeleton';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabsModule } from 'primeng/tabs';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { MultiSelectModule } from 'primeng/multiselect';
import { ScrollerModule } from 'primeng/scroller';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DividerModule } from 'primeng/divider';

const PRIMENG_MODULES = [
  CardModule,
  ButtonModule,
  TableModule,
  InputTextModule,
  DatePicker,
  Skeleton,
  SkeletonModule,
  ProgressBarModule,
  ProgressSpinnerModule,
  TabsModule,
  CheckboxModule,
  ChipModule,
  SelectModule,
  PopoverModule,
  MultiSelectModule,
  ScrollerModule,
  IconFieldModule,
  InputIconModule,
  DividerModule
];

@NgModule({
  declarations: [],
  imports: [...PRIMENG_MODULES],
  exports: [...PRIMENG_MODULES],
  providers: [DialogService, DynamicDialogConfig, DynamicDialogRef]
})
export class PrimengExportsModule {}
